import { Component, ElementRef, NgZone, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CustomerService } from '../../../_services';

@Component({
  selector: 'app-new-apikey-webhook-version',
  templateUrl: './new-apikey-webhook-version.component.html',
  styleUrls: [
    './new-apikey-webhook-version.component.css',
    '../../../../assets/css/new-component-view.css',
    '../../../../assets/css/new-form-elements.css',
    '../../../../assets/css/new-buttons-theme.css'
  ]
})
export class NewApiKeyWebhookComponent implements OnInit, OnDestroy {

  private customerPublicId: string;
  activeTab: string | null = null;
  tabOffsetLeft: number;
  tabOffsetWidth: number;
  private destroy$ = new Subject<void>();
  @ViewChildren('tabItem') tabItems: QueryList<ElementRef>;

  items = [
    'API',
    'Webhook'
  ]

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private customerService: CustomerService
  ) {
  }

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }

    this.initTabLinePosition(this.items[0]);
  }

  initTabLinePosition(tabName: string) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.setActiveTab(tabName);
      });
    });
  }

  setActiveTab(tabName: string) {
    this.activeTab = tabName;
    const tabItem = this.tabItems.toArray().find(item => item.nativeElement.getAttribute('data-id') === tabName).nativeElement as HTMLElement;
    if (tabItem) {
      this.tabOffsetLeft = tabItem.offsetLeft;
      this.tabOffsetWidth = tabItem.offsetWidth;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
